import {
  GET_INITIAL_DASHBOARD_DATA,
  GET_CRS_DASHBOARD_SEGMENT_LIST_DATA,
  GET_CRS_DASHBOARD_SEGMENT_LIST_DATA_FAIL,
  GET_CRS_DASHBOARD_SEGMENT_LIST_DATA_SUCCESS,
  GET_CRS_MODEL_LIST_DATA,
  GET_CRS_MODEL_LIST_DATA_SUCCESS,
  GET_CRS_MODEL_LIST_DATA_FAIL,
  GET_CRS_CLUSTER_CHART_DATA,
  GET_CRS_CLUSTER_CHART_DATA_SUCCESS,
  GET_CRS_CLUSTER_CHART_DATA_FAIL,
  GET_CRS_CLUSTER_FEATURES_DATA,
  GET_CRS_CLUSTER_FEATURES_DATA_SUCCESS,
  GET_CRS_CLUSTER_FEATURES_DATA_FAIL,
  GET_CRS_CLUSTER_CUSTOMER_LIST_DATA,
  GET_CRS_CLUSTER_CUSTOMER_LIST_DATA_SUCCESS,
  GET_CRS_CLUSTER_CUSTOMER_LIST_DATA_FAIL,
  GET_CRS_FEATURE_CATEGORY_CODES,
  GET_CRS_FEATURE_CATEGORY_CODES_SUCCESS,
  GET_CRS_FEATURE_CATEGORY_CODES_FAIL,
  RESET_CRS_DASHBOARD
} from '../../actions/crs/crsDashboard';

export const initialState = {
  segmentList: { isLoading: false, data: null, error: null },
  modelList: { isLoading: false, data: null, error: null },
  clusterChartData: { isLoading: false, data: null, error: null },
  clusterFeaturesData: { isLoading: false, data: null, error: null },
  customerList: { isLoading: false, data: {}, error: null },
  featureCategoryCodes: { isLoading: false, data: null, error: null }
};

function crsDashboard(state = initialState, action) {
  switch (action.type) {
    // get initial dashboard data
    case GET_INITIAL_DASHBOARD_DATA:
      return {
        ...state,
        modelList: {
          isLoading: true,
          data: [{ value: '-', label: 'Loading models...' }],
          error: null
        },
        clusterChartData: { isLoading: true, data: [], error: null }
      };

    // Segment list

    case GET_CRS_DASHBOARD_SEGMENT_LIST_DATA:
      return {
        ...state,
        segmentList: {
          isLoading: true,
          data: [{ id: '-', name: 'Loading segments...' }],
          error: null
        }
      };
    case GET_CRS_DASHBOARD_SEGMENT_LIST_DATA_SUCCESS:
      return {
        ...state,
        segmentList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_DASHBOARD_SEGMENT_LIST_DATA_FAIL:
      return {
        ...state,
        segmentList: { isLoading: false, data: null, error: action.payload }
      };

    // Segment list

    case GET_CRS_MODEL_LIST_DATA:
      return {
        ...state,
        modelList: {
          isLoading: true,
          data: [{ value: '-', label: 'Loading models...' }],
          error: null
        }
      };
    case GET_CRS_MODEL_LIST_DATA_SUCCESS:
      return {
        ...state,
        modelList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_MODEL_LIST_DATA_FAIL:
      return {
        ...state,
        modelList: { isLoading: false, data: null, error: action.payload }
      };

    // Cluster Chart data

    case GET_CRS_CLUSTER_CHART_DATA:
      return {
        ...state,
        clusterChartData: { isLoading: true, data: [], error: null }
      };
    case GET_CRS_CLUSTER_CHART_DATA_SUCCESS:
      return {
        ...state,
        clusterChartData: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_CLUSTER_CHART_DATA_FAIL:
      return {
        ...state,
        clusterChartData: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    // Cluster Features Data

    case GET_CRS_CLUSTER_FEATURES_DATA:
      return {
        ...state,
        clusterFeaturesData: { isLoading: true, data: null, error: null }
      };
    case GET_CRS_CLUSTER_FEATURES_DATA_SUCCESS:
      return {
        ...state,
        clusterFeaturesData: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_CLUSTER_FEATURES_DATA_FAIL:
      return {
        ...state,
        clusterFeaturesData: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    // Customer List

    case GET_CRS_CLUSTER_CUSTOMER_LIST_DATA:
      return {
        ...state,
        customerList: { isLoading: true, data: {}, error: null }
      };
    case GET_CRS_CLUSTER_CUSTOMER_LIST_DATA_SUCCESS:
      return {
        ...state,
        customerList: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_CLUSTER_CUSTOMER_LIST_DATA_FAIL:
      return {
        ...state,
        customerList: { isLoading: false, data: {}, error: action.payload }
      };

    // Feature Category codes

    case GET_CRS_FEATURE_CATEGORY_CODES:
      return {
        ...state,
        featureCategoryCodes: { isLoading: true, data: [], error: null }
      };
    case GET_CRS_FEATURE_CATEGORY_CODES_SUCCESS:
      return {
        ...state,
        featureCategoryCodes: {
          isLoading: false,
          data: action.payload,
          error: null
        }
      };
    case GET_CRS_FEATURE_CATEGORY_CODES_FAIL:
      return {
        ...state,
        featureCategoryCodes: {
          isLoading: false,
          data: null,
          error: action.payload
        }
      };

    case RESET_CRS_DASHBOARD:
      return {
        ...state,
        clusterChartData: { isLoading: false, data: null, error: null },
        clusterFeaturesData: { isLoading: false, data: null, error: null },
        customerList: { isLoading: false, data: {}, error: null },
        featureCategoryCodes: { isLoading: false, data: null, error: null }
      };
    default:
      return {
        ...state
      };
  }
}

export default crsDashboard;
